// extracted by mini-css-extract-plugin
export default {"header":"Header_header__nhXRD","headerWrappper":"Header_headerWrappper__gSNyv","menu":"Header_menu__51Uci","active":"Header_active__2LoP+"};